import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Popover from "@material-ui/core/Popover";
import { makeStyles } from "@material-ui/core/styles";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Container from "@saleor/components/Container";
import FilterBar from "@saleor/components/FilterBar";
import PageBreadcrumbNavigation from "@saleor/components/PageBreadcrumbNavigation/PageBreadcrumbNavigation";
import PageHeader from "@saleor/components/PageHeader";
import {
  SaleListUrlDialog,
  SaleListUrlSortField
} from "@saleor/discounts/urls";
import useUser from "@saleor/hooks/useUser";
import { sectionNames } from "@saleor/intl";
import { Brand } from "@saleor/products/customTypes/Brand";
import {
  FilterPageProps,
  ListActions,
  PageListProps,
  SortPage,
  TabPageProps
} from "@saleor/types";
import { SmopUserTypeCode } from "@saleor/types/globalTypes";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { SaleList_sales_edges_node } from "../../types/SaleList";
import SaleList from "../SaleList";
import SaleSellerDropdown from "../SaleSellerDropdown";
import {
  createFilterStructure,
  SaleFilterKeys,
  SaleListFilterOpts
} from "./filters";

const useStyles = makeStyles(
  theme => ({
    [theme.breakpoints.up("lg")]: {
      colEnd: {
        width: 250
      },
      colName: {},

      colStart: {
        width: 250
      },
      colValue: {
        width: 200
      }
    },
    buttonUpload: {
      background: theme.palette.background.paper,
      borderRadius: "100%",
      height: 32,
      margin: theme.spacing(0, 3),
      padding: 0,
      width: 32
    },
    colEnd: {
      textAlign: "right"
    },
    colName: {
      paddingLeft: 0
    },

    colStart: {
      textAlign: "right"
    },
    colStatus: {
      textAlign: "left",
      width: "150px"
    },
    colValue: {
      textAlign: "right"
    }
  }),
  { name: "SaleListCard" }
);

export interface SalesKAMSDropdownProps {
  brand?: string;
  kamsBrands?: Brand[];
  brandLabel?: string;
  onBrandChange?: (e) => void;
  isKAMS: boolean;
}

export interface SaleListPageProps
  extends PageListProps,
    ListActions,
    FilterPageProps<SaleFilterKeys, SaleListFilterOpts>,
    SortPage<SaleListUrlSortField>,
    TabPageProps,
    SalesKAMSDropdownProps {
  defaultCurrency: string;
  sales: SaleList_sales_edges_node[];
  onUpload: (action: SaleListUrlDialog) => void;
}

const SaleListPage: React.FC<SaleListPageProps> = ({
  currencySymbol,
  currentTab,
  filterOpts,
  initialSearch,
  onAdd,
  onAll,
  onFilterChange,
  onSearchChange,
  onTabChange,
  onTabDelete,
  onTabSave,
  onUpload,
  tabs,
  brand,
  kamsBrands,
  brandLabel,
  onBrandChange,
  isKAMS,
  ...listProps
}) => {
  const intl = useIntl();
  const { user } = useUser();
  const structure = createFilterStructure(intl, filterOpts);
  const classes = useStyles("");

  const [anchorUpload, setAnchorUpload] = React.useState(null);
  const openUpload = Boolean(anchorUpload);

  const breadcrumbDirectory = [
    {
      name: "Sales"
    }
  ];

  return (
    <Container>
      {isKAMS && (
        <SaleSellerDropdown
          brand={brand}
          brandLabel={brandLabel}
          brandChoices={kamsBrands}
          onBrandChange={onBrandChange}
        />
      )}
      <PageBreadcrumbNavigation items={breadcrumbDirectory} />
      <PageHeader title={intl.formatMessage(sectionNames.sales)}>
        {(user.userType.code === SmopUserTypeCode.SELLER_MASTER || isKAMS) && (
          <>
            <IconButton
              className={classes.buttonUpload}
              onClick={e => setAnchorUpload(e.currentTarget)}
              // color="primary"
              // variant="contained"
              data-test="add-product"
              // startIcon={<CloudUploadIcon />}
            >
              {/* <FormattedMessage defaultMessage="Upload" description="button" /> */}
              <MoreVertIcon />
            </IconButton>
            <Popover
              // id={id}
              open={openUpload}
              anchorEl={anchorUpload}
              onClose={() => setAnchorUpload(null)}
              anchorOrigin={{
                horizontal: "center",
                vertical: "bottom"
              }}
              transformOrigin={{
                horizontal: "center",
                vertical: "top"
              }}
            >
              <Menu
                id="verticalEllipsesBtn"
                anchorEl={anchorUpload}
                keepMounted
                open={openUpload}
                onClose={() => setAnchorUpload(null)}
                anchorOrigin={{
                  horizontal: "center",
                  vertical: "bottom"
                }}
                transformOrigin={{
                  horizontal: "center",
                  vertical: "top"
                }}
                elevation={0}
                getContentAnchorEl={null}
              >
                <>
                  <MenuItem
                    id="uploadSalesMerchantAbsoluteBtn"
                    onClick={() => {
                      onUpload("uploadSalesMerchantAbsolute");
                      setAnchorUpload(null);
                    }}
                  >
                    <FormattedMessage
                      defaultMessage="Upload a Merchant Absolute Value Template File"
                      description="import products to csv file, button"
                    />
                  </MenuItem>
                  <MenuItem
                    id="uploadSalesPartnerAbsoluteBtn"
                    onClick={() => {
                      onUpload("uploadSalesPartnerAbsolute");
                      setAnchorUpload(null);
                    }}
                  >
                    <FormattedMessage
                      defaultMessage="Upload a Partnership Absolute Value Template File"
                      description="import products to csv file, button"
                    />
                  </MenuItem>
                  <MenuItem
                    id="uploadSalesMerchantPercentageBtn"
                    onClick={() => {
                      onUpload("uploadSalesMerchantPercentage");
                      setAnchorUpload(null);
                    }}
                  >
                    <FormattedMessage
                      defaultMessage="Upload a Merchant Percentage Sale Template File"
                      description="import products to csv file, button"
                    />
                  </MenuItem>
                  <MenuItem
                    id="uploadSalesPartnerPercentageBtn"
                    onClick={() => {
                      onUpload("uploadSalesPartnerPercentage");
                      setAnchorUpload(null);
                    }}
                  >
                    <FormattedMessage
                      defaultMessage="Upload a Partnership Percentage Sale Template File"
                      description="import products to csv file, button"
                    />
                  </MenuItem>
                </>
              </Menu>
            </Popover>
          </>
        )}
        {/* {user.userType.code === SmopUserTypeCode.SELLER_MASTER && (
          <Button
            style={{ marginRight: "10px" }}
            onClick={() => onUpload("uploadSalesProduct")}
            color="primary"
            variant="contained"
            startIcon={<CloudUploadIcon />}
          >
            <FormattedMessage defaultMessage="Upload" description="button" />
          </Button>
        )} */}
        <Button
          onClick={onAdd}
          variant="contained"
          color="primary"
          id="createSaleBtn"
        >
          <FormattedMessage defaultMessage="Create Sale" description="button" />
        </Button>
      </PageHeader>
      <Card>
        <FilterBar
          allTabLabel={intl.formatMessage({
            defaultMessage: "All",
            description: "tab name"
          })}
          currencySymbol={currencySymbol}
          currentTab={currentTab}
          filterStructure={structure}
          initialSearch={initialSearch}
          searchPlaceholder={intl.formatMessage({
            defaultMessage: "Search Sale"
          })}
          tabs={tabs}
          onAll={onAll}
          onFilterChange={onFilterChange}
          onSearchChange={onSearchChange}
          onTabChange={onTabChange}
          onTabDelete={onTabDelete}
          onTabSave={onTabSave}
        />
        <SaleList {...listProps} />
      </Card>
    </Container>
  );
};
SaleListPage.displayName = "SaleListPage";
export default SaleListPage;
